import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, PackageCheck, PackagePlus, RefreshCw, Truck, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const ActivitySection = () => {
  const activities = [
    {
      id: "activity-1",
      icon: <PackagePlus className="h-4 w-4 text-green-500" />,
      title: "Yeni Bağış Girişi",
      description: "15 koli giysi bağışı alındı.",
      time: "5 dakika önce",
    },
    {
      id: "activity-2",
      icon: <Truck className="h-4 w-4 text-blue-500" />,
      title: "Sevkiyat Tamamlandı",
      description: "Adana sevkiyatı başarıyla tamamlandı.",
      time: "30 dakika önce",
    },
    {
      id: "activity-3",
      icon: <PackageCheck className="h-4 w-4 text-purple-500" />,
      title: "Stok Güncellemesi",
      description: "Depodaki stoklar güncellendi.",
      time: "1 saat önce",
    },
    {
      id: "activity-4",
      icon: <Users className="h-4 w-4 text-orange-500" />,
      title: "Yeni Kullanıcı",
      description: "Sisteme yeni bir kullanıcı eklendi.",
      time: "2 saat önce",
    },
    {
      id: "activity-5",
      icon: <RefreshCw className="h-4 w-4 text-red-500" />,
      title: "Veri Senkronizasyonu",
      description: "Veriler başarıyla senkronize edildi.",
      time: "3 saat önce",
    },
    {
      id: "activity-6",
      icon: <Package className="h-4 w-4 text-gray-500" />,
      title: "Paketleme İşlemi",
      description: "Yeni yardım paketleri hazırlanıyor.",
      time: "4 saat önce",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Son Aktiviteler</CardTitle>
        <CardDescription>Sistemdeki son hareketler</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <ScrollArea className="h-[300px] w-full">
          <div className="space-y-4 p-4">
            {activities.map((activity) => (
              <div key={activity.id} className="flex items-center space-x-3">
                <div className="rounded-full bg-secondary p-1">
                  {activity.icon}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium leading-none">{activity.title}</p>
                  <p className="text-sm text-muted-foreground">{activity.description}</p>
                </div>
                <div className="text-xs text-muted-foreground">{activity.time}</div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default ActivitySection;
